import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { navItems } from './NavMaterials';
import './Navbar.css';

const Navbar = () => {
  const [menu, setMenu] = useState(false);

  const closeMenu = () => {
    setMenu(false);
  };

  // Use useEffect to properly handle scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      setMenu(false);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to handle smooth scrolling to sections
  const handleScrollToSection = (id) => {
    // Close mobile menu first
    closeMenu();

    // Handle home route
    if (id === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // Find the element by ID and scroll to it
    const element = document.getElementById(id);
    if (element) {
      const navbarHeight = 80; // Adjust based on your navbar height
      const elementPosition = element.offsetTop - navbarHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  };

  const hamburger = (
    <button
      className="hamburger-container"
      onClick={() => setMenu(!menu)}
      aria-label="Toggle menu"
    >
      <div className={menu ? 'close-hamburger' : 'hamburger'}>
        <span className="ham-span"></span>
        <span className="ham-span"></span>
        <span className="ham-span"></span>
      </div>
    </button>
  );

  const dropdown = (
    <div className={`fullscreen-menu ${menu ? 'active' : ''}`}>
      {/* Close button */}
      <button
        className="close-button"
        onClick={closeMenu}
        aria-label="Close menu"
      >
        ✕
      </button>

      {/* Navigation items */}
      <div className="menu-items">
        {navItems.map(({ name, id }) =>
          id === '/blog' ? (
            <Link
              key={id}
              to="/blog"
              className="menu-nav-item"
              onClick={closeMenu}
            >
              {name}
            </Link>
          ) : (
            <button
              key={id}
              className="menu-nav-item"
              onClick={() => handleScrollToSection(id)}
            >
              {name}
            </button>
          )
        )}
      </div>
    </div>
  );

  // Desktop navigation
  // const desktopNav = (
  //   <div className="hidden lg:flex space-x-8">
  //     {navItems.map(({ name, id }) => (
  //       <button
  //         key={id}
  //         className="nav-item text-white hover:text-primary transition-colors duration-300"
  //         onClick={() => handleScrollToSection(id)}
  //       >
  //         {name}
  //       </button>
  //     ))}
  //   </div>
  // );

  return (
    <nav className="navbar top-0 left-0 right-0 z-50">
      <div className="flex justify-between items-center p-6">
        {/* Logo */}
        <div className="font-black text-lg sm:text-2xl lg:text-4xl text-white hover:text-primary transition-colors duration-300">
          <Link to="/">Parvez Hasan Rubel</Link>
        </div>

        {/* Hamburger Menu - Show on all screen sizes */}
        {hamburger}
      </div>

      {/* Fullscreen Menu */}
      {menu && dropdown}
    </nav>
  );
};

export default Navbar;
